class Count {
  constructor(private readonly _value: number = NaN) {
  }

  public isEmpty(): boolean {
    return isNaN(this._value) || this._value === 0;
  }

  public toString() {
    return `${ this._value } 件`;
  }
}

export default Count;
